<template>
  <header>
    <div class="top-menu w-100">
      <div class="container h-100">
        <div class="row h-100">
          <div
            class="col-lg-4 col-sm-8 header-logo h-100 align-self-center d-flex align-items-center"
          >
            <router-link to="/" class="logo-text">
              <img
                class="logo"
                src="@/assets/images/SeaScaffoldingLogo.png"
                alt="Sea Scaffolding Logo"
              />
            </router-link>
          </div>
          <MobileMenu></MobileMenu>
          <div class="col-lg-8 h-100 navigation">
            <ul class="header-nav-items h-100 d-flex align-items-center menu">
              <li>
                <router-link class="header-nav-link" to="/about-us/">About us</router-link>
              </li>
              <li>
                <router-link class="header-nav-link" to="/services/">Services</router-link>
              </li>
              <li>
                <router-link class="header-nav-link" to="/past-projects/">Past projects</router-link>
              </li>
              <li>
                <router-link class="header-nav-link" to="/contact-us/">Contact Us</router-link>
              </li>
              <li>
                <a href="tel:01502711750" class="header-nav-link">
                  <strong>01502 711750</strong>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import MobileMenu from "@/components/partials/MobileMenu";

export default {
  name: "main-header",
  components: {
    MobileMenu
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/partials/MainHeader.vue